import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PermsRolesDirective } from "./directives/perms-roles.directive";
import { PermsRolesDisabledDirective } from "./directives/perms-roles-disabled.directive";
import { PriceFormatDirective } from "./directives/price-format.directive";

@NgModule({
  declarations: [PermsRolesDirective, PermsRolesDisabledDirective, PriceFormatDirective],
  imports: [CommonModule],
  exports: [PermsRolesDirective, PermsRolesDisabledDirective, PriceFormatDirective],
})
export class CoreModule {}
